<template>
	<header class="header" :class="{'header--inversed' : props.inversed}">
		<div class="header__left">
			<button type="button" @click="goBack" v-if="props.back" class="header__back">
				<Icon name="left" />
			</button>
		</div>
		<div class="header__center">
			<h1 class="header__title" v-if="title">{{ title }}</h1>
			<i class="header__logo" v-else></i>
		</div>
		<div class="header__right">
			<slot name="right" :go-back="goBack">
				<RouterLink color="brand" to="/notifications" class="header__notifications header-notifications" :class="{'header-notifications--inversed' : props.inversed}">
					<Icon name="notifications" />
					<i class="header-notifications__count" v-if="unread > 0">{{ unread }}</i>
				</RouterLink>
				<RouterLink color="light" to="/settings" class="header__settings">
					<Icon name="settings" />
				</RouterLink>
			</slot>
		</div>
	</header>
</template>
<script setup lang="ts">
import {ref} from "vue";
import "./Header.scss";
import {RouterLink, useRoute, useRouter} from "vue-router";
import Icon from "@/components/Icon/Icon.vue";
import {useUserStore} from "@/stores/userStore";
import {storeToRefs} from "pinia";
import {useNotificationsStore} from "@/stores/notificationsStore";

interface Props{
	title? : string,
	back? : boolean | string | Function,
	inversed? : boolean
}

let props = withDefaults(defineProps<Props>(), {
	inversed : false,
	back : false
});

let router = useRouter();
let notificationsStore = useNotificationsStore();

let {notifications, unread} = storeToRefs(notificationsStore);

let goBack = () => {

	if(typeof props.back === 'string'){
		router.push(props.back);
	}else if(typeof props.back === 'function'){
		props.back();
	}else{
		router.back();
	}

}

</script>
